var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectListEmptyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75.3633,
    r: 75,
    fill: "#47484A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3337 92.03H91.667V100.363H58.3337V92.03ZM58.3337 75.3633H91.667V83.6967H58.3337V75.3633ZM83.3337 33.6967H50.0003C45.417 33.6967 41.667 37.4467 41.667 42.03V108.697C41.667 113.28 45.3753 117.03 49.9587 117.03H100C104.584 117.03 108.334 113.28 108.334 108.697V58.6967L83.3337 33.6967ZM100 108.697H50.0003V42.03H79.167V62.8633H100V108.697Z",
    fill: "#4FA736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectListEmptyDark);
export default __webpack_public_path__ + "static/media/project-list-empty-dark.95e080f99d825923d425867c4971dc43.svg";
export { ForwardRef as ReactComponent };